import React from "react"

import { Button, ChevronDown, ChevronUp, Icon } from "@cgtrader/triangle-ui/dist/src/ssr-index"
import { arrayOf, bool, func, shape, string } from "prop-types"

import { iconSize } from "Pods/ThreeDStudio/constants"

import DetailRows from "../DetailRows/DetailRows"

function CardBody({ rows, hasSettings, isExpanded, onToggle }) {
  return (
    <>
      <DetailRows rows={rows} />
      {hasSettings && (
        <Button
          actionType="button"
          type="ghost"
          variant="only-icon"
          size="tiny"
          className="model-details-card__toggle"
          onClick={onToggle}
          aria-expanded={isExpanded}
          aria-label={isExpanded ? 'Hide model settings' : 'Show model settings'}
          icon={
            <Icon svgComponent={isExpanded ? ChevronUp : ChevronDown} color="darker" size={iconSize} notSpaced />
          }
        />
      )}
    </>
  )
}

CardBody.propTypes = {
  rows: arrayOf(shape({ label: string.isRequired, value: string.isRequired })).isRequired,
  hasSettings: bool.isRequired,
  isExpanded: bool.isRequired,
  onToggle: func.isRequired,
}

export default CardBody
